<template lang="pug">
  el-main(v-loading="loading")
    el-row
      img(
        class="library-icon"
        :src="libraryIcon"
      )
      span#form-header {{ libraryLabel }}
      el-button.margin-left-15(
        class="normal-button"
        @click="$emit('showLibraryModal')"
        :loading="processing"
        icon="el-icon-notebook-2")
          small Switch
      div(style="float:right;")
        el-pagination(
          v-if="pagination.totalQuestions > maxPageLimit"
          :page-size="maxPageLimit"
          :total="pagination.totalQuestions"
          :current-page="pagination.currentPage"
          @next-click="pageChange(1)"
          @prev-click="pageChange(-1)"
          @current-change="handleCurrentChange"
          layout="prev, pager, next")
          
    el-row.margin-top-30(class="box-card") 
      // Question Builder
      div(v-if="showBuilder")
        question-builder(
          v-if="showBuilder"
          :pageView="pageview"
          :questionData="question"
          :tagsList="tagsList"
          @onProcessing="(flag) => loading = flag"
          @formCancelClicked="showBuilder = false"
          @onQuestionSaved="updateQuestion")
  
      // Tags Control Panel
      div(v-else)
        div(style="margin: 0% 2% 0% 2%; display: flex; flex-direction: row; justify-content: space-between; flex-wrap: wrap; align-items: baseline;")
          // Tag Selection Dropdown List
          el-select#tag-select(
            v-model="searchParams"
            multiple
            filterable
            reserve-keyword
            placeholder="Please enter a tag to search"
            no-data-text="No tags found"
            no-match-text="No tag matches found"
            :loading="loading")
            el-option#tag-options(
              v-for="item in tagsList"
              :key="item.id"
              :label="item.text"
              :value="item.text"
            )

          // Buttons
          div(style="float:left;")
            el-button(
                class="normal-button"
                @click="search(true)"
                :loading="processing"
                icon="el-icon-search")
                  small Search
            el-button(
                class="normal-button"
                @click="openTagDialog(-1)"
                :loading="processing"
                icon="el-icon-tickets")
                  small Tags List
          el-button(
            class="primary-button"
            style="float:right"
            icon="el-icon-edit"
            :loading="processing"
            @click="showTypeModal=true; questionType=0"
          )
            small Create New Question

        // Pagination
        el-row


        // Question List
        el-row(v-if="!loading")
          div(v-for="item in questionList")
              question-placeholder(
                :id="item.id" 
                :questionData="item"
                :showPreview="true"
                :selectOnly="false"
                :superAccess="true"
                :tagsList="tagsList"
                :tagUpdate="tagUpdate"
                @editQuestion="editQuestion"
                @hideItem="deleteQuestion" 
              )

        // Pagination
        el-row
          div(style="float:right; margin: 2%")
            el-pagination(
              v-if="pagination.totalQuestions > maxPageLimit"
              :page-size="maxPageLimit"
              :total="pagination.totalQuestions"
              :current-page="pagination.currentPage"
              @next-click="pageChange(1)"
              @prev-click="pageChange(-1)"
              @current-change="handleCurrentChange"
              layout="prev, pager, next")

        // Add Tag Modal
        tag-modal(
          v-if="isDialogVisible"
          :showDialog="isDialogVisible"
          :tagsList="tagsList"
          :tagId="currentTagId"
          :libraryIndex="libraryIndex"
          @onTagDeleted="deleteTag"
          @onTagUpdated="updateTag"
          @close="closeTagDialog"
        )

        question-type-modal(
          :visible-prop="showTypeModal"
          @close="showTypeModal = false"
          @formCancelClicked="showTypeModal = false"
          @createQuestion="createQuestion"
        )
</template>


<script>
  import QuestionPlaceholder from '@/components/instructor/Question/Placeholder/QuestionPlaceholder'
  import QuestionBuilder from '@/components/instructor/Question/QuestionBuilder'
  import QuestionTypeModal from '@/components/instructor/Question/Components/QuestionTypeModal'
  import TagModal from '@/components/superadmin/Tags/TagModal'
  import TagOption from '@/components/superadmin/Tags/TagOption'
  import utilMixin from '@/components/mixins/utilMixin'
  import {SUPER_QUIZ_ID, MAX_PAGE_LIMIT, LIBRARY_TYPES} from '@/defines/constants'

  export default {
    name: 'QuestionMasterLibrary',
    
    components: {
      QuestionPlaceholder,
      QuestionBuilder,
      QuestionTypeModal,
      TagModal,
      TagOption,
    },

    mixins: [utilMixin],

    props: {
      libraryType: {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        searchParams: [],
        tagsList: [],
        tagUpdate: null,
        questionList: [],
        question: {},
        pageview: '',
        loading: true,
        processing:false,
        showBuilder: false,
        showTypeModal: false,
        isDialogVisible: false,
        currentTagId: -1,
        pagination: {
          totalQuestions: 0,
          currentPage: 1,
        },
        questionType: 0,

        maxPageLimit: MAX_PAGE_LIMIT,
      }
    },

    computed: {
      libraryLabel: {
        get() {
          return this.libraryType.charAt(0).toUpperCase() + this.libraryType.slice(1) + ' Library'
        },
      },
      libraryIndex: {
        get() {
          return LIBRARY_TYPES[this.libraryType]
        },
      },
      /* eslint-disable */
      libraryIcon: {
        get() {
          return require(`@/assets/LibraryTypes/${this.libraryType}_library.svg`)
        }
      },
      /* eslint-enable */
    },

    watch: {
      libraryType() {
        this.fetchTags()
      },
    },

    mounted() {
      let quizData = { id:  SUPER_QUIZ_ID, resourceId:  SUPER_QUIZ_ID, isGraded: false, isEnrolled: false }
      this.$store.commit('setQuiz', quizData)
      this.fetchTags()
    },

    methods: {
      fetchTags() {
        this.tagsList = []
        this.questionList = []
        this.loading = true
        this.axios.get(`/api/tags/${this.libraryIndex}`)
          .then((result) => {
            result.data.tags.forEach((item) => {
                this.tagsList.push(item)
              })
            this.loading = false
            this.search()
          })
          .catch((error) => {
            this.mNotification({error: error, message: 'Unable to retrieve list of tags.'})
          })            
      },

      deleteTag(id) {
        for (let idx=0; idx<this.tagsList.length; idx++) {
          if ( this.tagsList[idx].id === id ) {
            this.tagUpdate = {id:-1, text:this.tagsList[idx].text}
            this.tagsList.splice(idx, 1)
            break
          }
        }
      },

      updateTag(id,text) {
        if ( id >= 0 ) {
          this.tagUpdate = {id:id, text:text} 
        }
        this.fetchTags()
      },

      createQuestion(type) {
        this.question = {
          title: '',
          text: '',
          lefthand: '',
          righthand: '',
          correct_answer: '',
          allow_math_equivs: true,
          score: 0,
          item_order: 0,
          type_id: type,
          custom_symbols: [],
          library: this.libraryIndex,
        }
        this.showBuilder = true
        this.showTypeModal = false
        this.pageview = 'create'
      },   

      editQuestion(id) {
        this.showBuilder = true
        this.pageview = 'edit'
      
        for (let i=0; i<this.questionList.length; i += 1) {
          if (this.questionList[i].id === id) {
            this.question = this.questionList[i]
            break
          }
        }
      },      

      deleteQuestion(id) {
        this.$emit('onProcessing', true)
        this.axios.delete('/api/quiz/' +  SUPER_QUIZ_ID  + '/question/' + id)
          .then((result) => {
            for (let idx=0; idx<this.questionList.length; idx += 1) {
              if ( this.questionList[idx].id === id) {
                this.pagination.totalQuestions -= 1
                this.questionList.splice(idx,1)
                break
              }
            }
            this.mNotification( {message: 'Your Question has been deleted.'})
            this.search()
          })
          .catch((error) => {
            this.mNotification({error: error, message: 'Your Question was not deleted.'})
          })
      
      },

      updateQuestion() {
        let isNew = true
        this.question.isSelected =true
        this.questionList.forEach((item,index)=> {
          if ( this.question.id === item.id ) {
            this.questionList[index] = this.question
            isNew = false
          } else {
             this.questionList[index].isSelected = false
          }
        })
        if ( isNew ) {
          this.pagination.totalQuestions += 1
          if (this.questionList.length === this.maxPageLimit) {
            this.questionList.pop()
          }
          this.questionList.unshift(this.question)
        }
        this.loading = false
        this.showBuilder = false
      },

      openTagDialog(index) {
        this.currentTagId = index
        this.isDialogVisible = true
      },

      closeTagDialog() {
        this.currentTagId = -1
        this.isDialogVisible = false
      },

      search(searchClicked) {
        let tagIds = []
        this.searchParams.forEach((item, index) => {
          for (let i=0; i<this.tagsList.length; i += 1) {
            if (this.tagsList[i].text === item) {
              tagIds.push(this.tagsList[i].id)
              break
            }
          }
        })

        let searchData = { library: this.libraryIndex }
        if (searchClicked !== undefined) {
          searchData.tagIds = tagIds
        } else {
          searchData.page = this.pagination.currentPage - 1
        }

        this.processing = true
        this.$emit('onProcessing', true)
        this.axios.get('/api/quiz/' +  SUPER_QUIZ_ID  + '/question', {
          params: searchData,
        })
          .then((result) => {
            if (result.data.object.length > 0 ) {
              this.questionList = []
              result.data.object.forEach((item, index) => {
                this.questionList.push(item)
              })
              this.pagination.totalQuestions = result.data.total
              if (searchClicked !== undefined) {
                this.pagination.currentPage = 1
              }
            }
            else {
              this.mNotification({title:"No Questions", warning:'No questions matched the given criteria.'})
            }
            this.processing = false
            this.$emit('onProcessing', false)
          })
          .catch((error) => {
            this.processing = false
            this.mNotification({error: error, message: 'Your Question list was not fully retrieved.'})
          })
      },  

      pageChange(step) {
        let totalPages = this.pagination.totalQuestions / this.maxPageLimit
        if (step > 0) {
          if (this.pagination.currentPage < totalPages) {
            this.pagination.currentPage += 1
          }
        } else {
          if (this.pagination.currentPage > 1) {
            this.pagination.currentPage -= 1
          }
        }
        this.search()
      },

      handleCurrentChange(page) {
        this.pagination.currentPage = page
        this.search()
      },
  },
}
</script>

<style>
  #tag-select {
    min-width: 350px;
  }

  #tag-options {
    font-size: 20px;
  }

  #form-header {
    font-size: 1.5em;
    font-weight:bold;
    color: #00a8ff;
  }

  .library-icon {
    width: 2.5em;
    height: 2.5em;
    padding-right: 0.5em;
    vertical-align: top;
  }
</style>